import clsx from 'clsx';
import type { FunctionComponent, HTMLAttributes, ReactNode } from 'react';

export type IconIndicatorProps = HTMLAttributes<HTMLDivElement> & {
    readonly children: ReactNode;
    readonly size?: 'm' | 'sm';
    readonly variant?: 'default' | 'highlighted';
};

const INSET_BOX_SHADOW =
    '0rem 0rem 0.0625rem 0rem rgba(66, 66, 66, 0.00), 0rem 0rem 0.0625rem 0rem rgba(66, 66, 66, 0.02), 0rem 0rem 0.0625rem 0rem rgba(66, 66, 66, 0.07), 0rem 0rem 0.0625rem 0rem rgba(66, 66, 66, 0.11), -0.015625rem -0.015625rem 0rem 0rem rgba(0, 0, 0, 0.05), 0.0625rem 0.0625rem 0.0625rem 0rem rgba(251, 251, 255, 0.75) inset, -0.03125rem -0.03125rem 0.0625rem 0rem rgba(0, 0, 0, 0.07) inset';

const sizeClasses = {
    m: 'h-8xl w-8xl',
    sm: 'h-7xl w-7xl',
} as const;

const variantClasses = {
    default: 'bg-gray-200 text-gray-600',
    highlighted: 'bg-orange-100 text-orange-500',
} as const;

export const IconIndicator: FunctionComponent<IconIndicatorProps> = ({
    children,
    className,
    size = 'sm',
    variant = 'default',
    ...props
}) => {
    return (
        <div
            className={clsx(
                'flex items-center justify-center shrink-0 rounded-md transition-[background,color] duration-200 ease-in-out',
                '[&_svg]:h-3xl [&_svg]:w-3xl',
                sizeClasses[size],
                variantClasses[variant],
                className,
            )}
            style={{ boxShadow: INSET_BOX_SHADOW }}
            {...props}
        >
            {children}
        </div>
    );
};
